__webpack_require__.p = "/tokens-new-pricing-plans/onboarding/";